/**
 * OVERRIDE Breadcrumbs.jsx
 */

import BreadcrumbsComponent from '../../../../components/Breadcrumbs/Breadcrumbs';

export default BreadcrumbsComponent;